<template>
  <div>
    <vs-popup title="Choose Course" :active.sync="attachToCourseModal">
      <div
        style="max-height: calc(100vh - 180px); overflow: auto"
        class="vertical_scrollbar"
        @scroll="detectsScrollLength()"
      >
        <vs-table
          class="assignment-table cstm_vuexy_table"
          v-model="selected"
          :data="courseLists"
        >
          <template slot="thead">
            <vs-th>Course Name</vs-th>
          </template>
          <template slot-scope="{ data }">
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
              <vs-td>
                {{ data[indextr].name }}
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </div>
      <vs-button class="mt-4" @click="attachToCourseFunc">
        Attach to Course</vs-button
      >
    </vs-popup>
  </div>
</template>
<script>
import { attachNoteToCourse } from '@/api/lesson_notes'
import { newcourseListing } from '@/api/course-builderapi'

export default {
  watch: {
    attachToCourseModal () {
      if (!this.attachToCourseModal) {
        this.$emit('attachToCourseModalFalse', true)
      }
    }
  },
  props: {
    attachToCourseModal: {
      default: false
    },
    note_id: {
      default: 0
    }
  },
  data () {
    return {
      courseLists: [],
      selected: [],
      meta: {
        current_page: 1,
        has_next: true,
        limit: 10,
        next_page_url: '',
        previous_page_url: null,
        total: null
      }
    }
  },
  mounted () {
    this.fetchCourseList()
    this.attatchScrollEvent()
  },
  methods: {
    attatchScrollEvent () {
      document
        .getElementsByClassName('vs-popup--content')[0]
        .addEventListener('scroll', this.detectsScrollLength)
    },
    detectsScrollLength () {
      const el = document.getElementsByClassName('vs-popup--content')[0]

      if (Math.ceil(el.scrollTop + el.offsetHeight) >= el.scrollHeight) {
        this.loadMoreCourses()
      }
    },
    async loadMoreCourses () {
      try {
        this.meta.current_page = this.meta.current_page + 1

        const customer_id = this.$store.getters.customerId

        const payload = {
          custom: 0
        }

        const data = await newcourseListing(
          customer_id,
          payload,
          this.meta.current_page,
          'course_table'
        )
        this.courseLists.push(...data.data.data.course)
        this.meta = data.data.data.meta
        this.meta.current_page = data.data.data.meta.current_page
      } catch (e) {
        //
      }
    },
    async attachToCourseFunc () {
      try {
        const payload = {
          courses: [this.selected.id]
        }
        await attachNoteToCourse(
          this.$store.getters.customerId,
          this.note_id,
          payload
        )

        this.$emit('attachToCourseModalFalse', true)

        this.showSuccessMessage(
          'Success',
          'Note attached successfully',
          'success'
        )
      } catch (e) {
        console.log(e)
      }
    },
    async fetchCourseList () {
      try {
        this.$vs.loading({
          text: 'Please Wait  ...'
        })
        const payload = {}

        if (this.courseApplicationType === 'General') {
          payload.custom = 0
        }

        if (this.courseApplicationType === 'Custom') {
          payload.custom = 1
        }

        const customer_id = this.$store.getters.customerId
        payload.limit = this.pageLimitSet

        const responeList = await newcourseListing(
          customer_id,
          payload,
          this.meta.current_page,
          {},
          'course_table'
        )

        this.courseLists = responeList.data.data.course
        this.meta = responeList.data.data.meta
      } catch (error) {
        console.log(error)
      } finally {
        this.$vs.loading.close()
      }
    }
  }
}
</script>
